import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "profile" }
const _hoisted_4 = { class: "danger" }
const _hoisted_5 = {
  key: 0,
  class: "collapse-content"
}
const _hoisted_6 = { class: "profile-header" }
const _hoisted_7 = { class: "infos" }
const _hoisted_8 = { class: "password-form" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_UserFilled = _resolveComponent("UserFilled")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.USER,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "rounded-content" }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _withDirectives(_createElementVNode("div", _hoisted_4, _cache[2] || (_cache[2] = [
                    _createElementVNode("h4", null, "Achtung:", -1),
                    _createElementVNode("p", null, "Es wurde noch kein Passwort vergeben. Ohne ein Passwort ist die Anmeldung mit diesem Benutzer unmöglich.", -1)
                  ]), 512), [
                    [_vShow, !_ctx.oldPassword && !_ctx.loadingPassword]
                  ]),
                  (!_ctx.loadingPassword)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_icon, { size: 64 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_UserFilled)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 2 }, {
                                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                                    _createTextVNode(" Vorname ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, { span: 22 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.userModel.firstname), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 2 }, {
                                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                                    _createTextVNode(" Nachname ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, { span: 22 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.userModel.lastname), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 2 }, {
                                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                                    _createTextVNode(" E-Mail ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, { span: 22 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.userModel.email), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _cache[6] || (_cache[6] = _createElementVNode("p", null, "Passwort ändern", -1))
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_el_form, {
                            ref: "editPasswordForm",
                            rules: _ctx.rules,
                            "status-icon": "",
                            "label-position": "top",
                            model: _ctx.passwordForm,
                            "label-width": "120px"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: "Passwort",
                                prop: "newPassword"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.passwordForm.newPassword,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.passwordForm.newPassword) = $event)),
                                    type: "password",
                                    autocomplete: "off",
                                    onInput: _ctx.onPasswordInput
                                  }, null, 8, ["modelValue", "onInput"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "Passwort wiederholen",
                                prop: "repeatPassword"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.passwordForm.repeatPassword,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.passwordForm.repeatPassword) = $event)),
                                    type: "password",
                                    autocomplete: "off",
                                    onInput: _ctx.onPasswordInput
                                  }, null, 8, ["modelValue", "onInput"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    disabled: !_ctx.formPasswordValid,
                                    onClick: _ctx.onPasswordSaveClick,
                                    loading: _ctx.loadingPassword
                                  }, {
                                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                                      _createTextVNode(" Speichern ")
                                    ])),
                                    _: 1
                                  }, 8, ["disabled", "onClick", "loading"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["rules", "model"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])), [
                  [_directive_loading, _ctx.loadingPassword]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}